// MsgMedia.jsx
import { useEffect, useRef, useState, memo } from "react";
import { Dialog, DialogContent } from "@mui/material";

// 1) Extrai texto e URLs do corpo da mensagem
export function splitTextAndUrls(text) {
  const t = String(text ?? "");
  const urls = t.match(/https?:\/\/[^\s)]+/g) || [];
  const textOnly = t.replace(/https?:\/\/[^\s)]+/g, "").trim();
  return { textOnly, urls };
}

// 2) Imagem com tratamento de cache e fallback para link
export const ChatImage = memo(function ChatImage({ url }) {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // se veio do cache, já considera carregada
    const el = imgRef.current;
    if (el && el.complete && el.naturalWidth > 0) setLoaded(true);
  }, [url]);

  if (!url) return null;

  return (
    <div style={{ display: "inline-block", maxWidth: "100%" }}>
      {!error && (
        <img
          ref={imgRef}
          src={url}
          alt="imagem"
          onLoad={() => setLoaded(true)}
          onError={() => { setLoaded(true); setError(true); }}
          loading="lazy"
          referrerPolicy="no-referrer"
          style={{
            display: "block",
            opacity: loaded ? 1 : 0,
            transition: "opacity .15s",
            maxWidth: "100%",
            maxHeight: 320,
            borderRadius: "0.5rem",
            cursor: "pointer",
            objectFit: "cover",
          }}
          onClick={() => {
            if (window.AndroidInterface && typeof window.AndroidInterface.redirectLink === "function") {
              window.AndroidInterface.redirectLink(url); // abrir no navegador do Android
            } else {
              window.open(url, "_blank", "noopener,noreferrer"); // fallback fora do WebView
            }
          }}
        />

      )}

      {/* Se falhar como imagem, mostra pelo menos o link */}
      {error && (
        <a href={url} target="_blank" rel="noreferrer" className="underline break-all" style={{ fontSize: 12 }}>
          {url}
        </a>
      )}

      {/* Preview em Dialog */}

      {/* <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
        <DialogContent dividers>
          <img src={url} alt="preview" style={{ width: "100%", height: "auto", display: "block" }} />
        </DialogContent>
      </Dialog> */}

    </div>
  );
});

// 3) Renderer de mensagem (texto + todas as URLs como imagens)
export function renderMsgContent(text) {
  const { textOnly, urls } = splitTextAndUrls(text);
  return (
    <>
      {textOnly && <span>{textOnly}</span>}
      {urls.length > 0 && (
        <div className="flex flex-col gap-2 mt-1">
          {urls.map((u) => (
            <ChatImage key={u} url={u} />
          ))}
        </div>
      )}
    </>
  );
}